import React from "react";

// Admin Imports
import MainDashboard from "views/admin/default";
import NFTMarketplace from "views/admin/marketplace";
import Profile from "views/admin/profile";
import DataTables from "views/admin/tables";
import PlanDeatils from "views/admin/plans";

// Icon Imports
import {
  MdHome,
  MdOutlineShoppingCart,  MdBarChart,
  MdPerson,
  MdLock,
  MdSource,
  MdWidgets
} from "react-icons/md";
import { IoChatboxEllipsesOutline } from "react-icons/io5";

import Login from "views/auth/SignIn";
import Register from "views/auth/Register";
import SetPassword from "views/auth/SetPassword";
import CheckEmail from "views/auth/CheckEmail";
import ForgotPassowrd from "views/auth/ForgotPassword";
import { IoCardSharp } from "react-icons/io5";
import { BsKeyFill } from "react-icons/bs";
import ChatWidget from "views/admin/chat_widget";
import DataSource from "views/admin/data_source";
import Chatbot from "views/admin/chatbot";
import { MdOutlineSpaceDashboard } from "react-icons/md";



const routes = [
  {
    name: "Dashboard",
    layout: "/admin",
    path: "dashboard",
    icon: <MdOutlineSpaceDashboard className="h-6 w-6" />,
    component: <MainDashboard />,
  },
  {
    name: "Logs",
    layout: "/admin",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "conversion-log",
    component: <DataTables />,
  },
  {
    name: "Chatbot",
    layout: "/admin",
    icon: <IoChatboxEllipsesOutline className="h-6 w-6" />,
    path: "chatbot",
    component: <Chatbot />,
  },
  // {
  //   name: "Data Source",
  //   layout: "/admin",
  //   icon: <MdSource className="h-6 w-6" />,
  //   path: "data-source",
  //   component: <DataSource />,
  // },
  // {
  //   name: "Chat Widget",
  //   layout: "/admin",
  //   icon: <MdWidgets className="h-6 w-6" />,
  //   path: "chat-widget",
  //   component: <ChatWidget />,
  // },
  // {
  //   name: "Profile",
  //   layout: "/admin",
  //   path: "profile",
  //   icon: <MdPerson className="h-6 w-6" />,
  //   component: <Profile />,
  // },
  {
    name: "Sign In",
    layout: "/",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <Login />,
  },
  {
    name: "Register",
    layout: "/",
    path: "register",
    icon: <MdLock className="h-6 w-6" />,
    component: <Register />,
  },
  {
    name: "Check Email",
    layout: "/",
    path: "check-email",
    icon: <MdLock className="h-6 w-6" />,
    component: <CheckEmail />,
  },
  {
    name: "Set Password",
    layout: "/",
    path: "set-password",
    icon: <MdLock className="h-6 w-6" />,
    component: <SetPassword />,
  },
  {
    name: "Forgot Password",
    layout: "/",
    path: "forgot-password",
    icon: <MdLock className="h-6 w-6" />,
    component: <ForgotPassowrd />,
  },
  // {
  //   name: "RTL Admin",
  //   layout: "/rtl",
  //   path: "rtl",
  //   icon: <MdHome className="h-6 w-6" />,
  //   component: <RTLDefault />,
  // },
];
export default routes;
